<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Odobreni Unosi</h4>
          </md-card-header>
          <md-card-content>
            <cisti-table table-header-color="green"></cisti-table>
          </md-card-content>
        </md-card>
      </div>

    </div>
  </div>
</template>

<script>
import { CistiTable } from "@/components";

export default {
  components: {
    CistiTable
  }
};
</script>
